module.exports = __webpack_public_path__ + "static/img/rule_icon.c1589df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rule_icon.png
// module id = MMzU
// module chunks = 1